import { render, staticRenderFns } from "./FiltroBalancete.vue?vue&type=template&id=2b4ddc09&"
import script from "./FiltroBalancete.vue?vue&type=script&lang=js&"
export * from "./FiltroBalancete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports